import type { NumberValue } from '../../../types/form/form-fields/field-values';
import type { ConstraintFunction } from '../../../types/form/form-section/config';

export const numberValueEqualToCheck: ConstraintFunction<NumberValue> = (
	value: NumberValue | undefined,
	constraint: string[],
) => value !== undefined && value.number === Number(constraint[0]);

export const numberValueDoesNotEqualToCheck: ConstraintFunction<NumberValue> = (
	value: NumberValue | undefined,
	constraint: string[],
) => value === undefined || value.number !== Number(constraint[0]);

export const numberValueGreaterThanCheck: ConstraintFunction<NumberValue> = (
	value: NumberValue | undefined,
	constraint: string[],
) => value !== undefined && value.number > Number(constraint[0]);

export const numberValueGreaterThanOrEqualToCheck: ConstraintFunction<NumberValue> = (
	value: NumberValue | undefined,
	constraint: string[],
) => value !== undefined && value.number >= Number(constraint[0]);

export const numberValueLessThanCheck: ConstraintFunction<NumberValue> = (
	value: NumberValue | undefined,
	constraint: string[],
) => value !== undefined && value.number < Number(constraint[0]);

export const numberValueLessThanOrEqualToCheck: ConstraintFunction<NumberValue> = (
	value: NumberValue | undefined,
	constraint: string[],
) => value !== undefined && value.number <= Number(constraint[0]);

// BETWEEN: Inclusive of minimum and maximum
export const numberValueBetweenCheck: ConstraintFunction<NumberValue> = (
	value: NumberValue | undefined,
	constraint: string[],
) => {
	if (value === undefined) {
		return false;
	}
	const min = Number(constraint[0]);
	const max = Number(constraint[1]);
	return value.number >= min && value.number <= max;
};

export const numberValueEmptyCheck: ConstraintFunction<NumberValue> = (
	value: NumberValue | undefined,
) => value === undefined || typeof value.number !== 'number';

export const numberValueNotEmptyCheck: ConstraintFunction<NumberValue> = (
	value: NumberValue | undefined,
) => value !== undefined && typeof value.number === 'number';
